import {Component, OnInit} from '@angular/core';
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {Subscription} from "rxjs";
import {LanguageService} from "../../../services/language.service";

@Component({
  selector: 'app-dialog-disclaimer',
  standalone: true,
  imports: [
    MatDialogModule, MatButtonModule
  ],
  templateUrl: './dialog-disclaimer.component.html',
  styleUrl: './dialog-disclaimer.component.css'
})
export class DialogDisclaimerComponent implements OnInit {
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;


  private subscriptions: Subscription = new Subscription();

  constructor(private _languageService: LanguageService,
              private _translate: TranslateService) {
  }

  ngOnInit(): void {
    this.setupLanguageSubscription();
  }

  onCancel(): void {
    window.location.href = 'https://dr-blumer.li';
  }

  private setupLanguageSubscription(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      })
    );
  }


}
